module.exports = __webpack_public_path__ + "portal/assets/img/logo.cc0dac95.svg";